/* @flow */

import React from 'react';
import cx from 'classnames';

import { branch } from '../../utils';
import MultiLineGraph from '../MultiLineGraph';
import LineGraph from '../LineGraph';


import classes from './ChartLineGraph.scss';

// const log = require('bows')('ChartLineGraph');

type ChartInfoType = {
  Detail: string,
  x: string,
  y1: string,
  y2: string,
};

type PropsType = {
  chartData: {},
  chartInfo: ChartInfoType,
  chartMarker: {},
  graphNum: string,
};

export class ChartLineGraph extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    chartData: [],
    chartInfo: {},
    graphNum: '#',
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    // Set up our props for later
    const props = {
      data: this.props.chartData,
      labels: this.props.chartInfo,
      markers: this.props.chartMarker,
      width: '100%',
      height: 300,
      viewBox: {
        x: 0,
        y: 0,
        width: 350,
        height: 225,
      },
    };

    // log(this.props.chartData);

    const multiLine = Object.keys(this.props.chartData).length > 3
      || this.props.graphNum === '7'
      || this.props.graphNum === '8';

    const Graph = branch(
      multiLine,
      MultiLineGraph,
      LineGraph,
    );

    return (
      <div>
        <Graph {...props} />
        <div className={cx(classes.chartDetails, 'px-5 pb-5 pt-0 d-flex')}>
          <div className={'w-75'}>
            <strong>Graph {this.props.graphNum}</strong>
            {' '}&mdash;{' '}
            {this.props.chartInfo.Detail}
          </div>
        </div>
      </div>
    );
  }
}

export default ChartLineGraph;



// WEBPACK FOOTER //
// ./src/components/ChartLineGraph/ChartLineGraph.js